import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useLanguage} from "i18n/LanguageProvider";
import {withLanguagePrefix} from "./hooks";

interface LanguageRedirectProps {
    to: string;
    replace?: boolean;
}

export const LanguageRedirect: React.FC<LanguageRedirectProps> = ({to, replace = true}) => {
    const {lang} = useLanguage();
    const navigate = useNavigate();

    useEffect(() => {
        navigate(withLanguagePrefix(lang, to), {replace});
    }, [lang, navigate, replace, to]);

    return null;
};
